var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.045 2.62016L6.23001 8.58516C6.18001 8.63516 6.18001 8.68516 6.13001 8.73516L5.38501 10.8702L7.72001 10.0752C7.77001 10.0752 7.82001 10.0252 7.87001 9.97516L13.635 4.06016C13.785 3.86016 13.935 3.61516 13.985 3.26516C14.035 2.96516 13.985 2.67016 13.635 2.42016C13.285 2.17016 12.99 2.12016 12.69 2.22016C12.44 2.32016 12.195 2.47016 12.045 2.61516V2.62016Z",
    stroke: "#0d4892",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16 2.39453H2V13.8245H13.68V8.65453",
    stroke: "#0d4892",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.854063c45d14e50e6c775e700f5cc4be.svg";
export { ForwardRef as ReactComponent };